<script lang="ts">
  import { P } from 'flowbite-svelte'
  import { readerFontFamily } from '$lib/reader-fonts'
  import { readerOpts } from '$lib/store'

  const {  raw, children }  = $props()
  const align = raw.startsWith('%center%') ? 'center' : 'left'

</script>

{#key $readerOpts }
 <P
    style="font-family: {readerFontFamily($readerOpts.bodyFont)};
    font-size: {$readerOpts.fontSize}px;
    margin-inline: {($readerOpts.margin?.novel ?? 0) / 2}%;
    line-height: calc(var(--spacing) * {$readerOpts.verticalSpacing});"
    upperClass="inner-content"
    color="text-gray-900 dark:text-gray-300"
    class="font-light
    {$readerOpts.justify ?  "text-justify" : ""}"
    {align}
  >
    {@render children()}
  </P>
{/key}
